
class CacheService {
  private cache = new Map<string, any>();

  set(key: string, value: any): void {
    const cacheValue = { timestamp : Date.now(), value: value }
    this.cache.set(key, cacheValue);
  }

  get(key: string): any {
    return this.has(key) ? this.cache.get(key) : null;
  }

  has(key: string): boolean {
    if(this.cache.has(key)) { 
      const cacheValue = this.cache.get(key);
      if(Date.now() - cacheValue.timestamp > 30 * 60* 1000) {
        this.cache.delete(key);
        return false;
      }
      return true;
    }
    return false;
  }

  remove(key: string): boolean {
    return this.cache.delete(key);
  }

  clear(): void {
    this.cache.clear();
  }
}

const g = (globalThis as any);

if(!g._globalCacheService) {
  g._globalCacheService = new CacheService();
}

export const cacheService = g._globalCacheService;